<ng-container *ngIf="result">
  <p class="sim-sample" data-test="sim-sample">
    <strong>{{ result.sample.companies }}</strong>
    {{ result.sample.companies === 1 ? 'empresa comparada' : 'empresas comparadas' }} de {{ result.sample.considered }}
    <ng-container *ngIf="!byPreoffer"
      >{{ result.sample.considered === 1 ? 'cliente' : 'clientes' }} con foto, de la más reciente a la más vieja.</ng-container
    >
    <ng-container *ngIf="byPreoffer"
      >{{ result.sample.considered === 1 ? 'cliente nuevo' : 'clientes nuevos' }} con preoferta decidida, del más reciente al más
      viejo.</ng-container
    >
  </p>
  <p class="sim-muted" *ngIf="sameVersion" data-test="sim-same">
    Es la versión activa: las dos columnas coinciden y muestran cómo califica hoy.
  </p>
  <ul class="sim-notes" *ngIf="notes.length" data-test="sim-notes">
    <li *ngFor="let note of notes">{{ note }}</li>
  </ul>

  <div class="sim-empty" *ngIf="!result.sample.considered && byPreoffer" role="status" data-test="sim-empty-preoffers">
    <i class="pi pi-inbox" aria-hidden="true"></i>
    <span>Todavía no hay preofertas decididas: no hay clientes nuevos que comparar.</span>
  </div>
  <div class="sim-empty" *ngIf="!result.sample.companies && (result.sample.considered || !byPreoffer)" role="status" data-test="sim-empty">
    <i class="pi pi-inbox" aria-hidden="true"></i>
    <span>No hay empresas con foto calculable en la muestra: no hay nada que comparar.</span>
  </div>

  <section class="sim-section" *ngIf="result.preoffers && result.sample.considered" data-test="sim-preoffers">
    <h3>Preofertas</h3>
    <p class="sim-muted">
      Con el puntaje mínimo de la preoferta ({{ result.preoffers.minTotalScore | number: '1.0-2' }}) y la elegibilidad que quedó al decidir:
      tope, anticipo, tipo de activo y obligado no dependen de la calculadora.
    </p>
    <div class="sim-table-wrap">
      <table class="sim-table" data-test="sim-preoffer-routes">
        <thead>
          <tr>
            <th scope="col">A dónde iría</th>
            <th scope="col" class="num">{{ baselineLabel }}</th>
            <th scope="col" class="num">{{ candidateLabel }}</th>
            <th scope="col" class="num">Cambio</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of preofferRoutes; trackBy: trackByKey" [attr.data-test]="'sim-route-' + row.key">
            <th scope="row">
              <span class="band-pill" [ngClass]="'is-' + row.tone">{{ row.label }}</span>
            </th>
            <td class="num">{{ row.baseline }}</td>
            <td class="num">{{ row.candidate }}</td>
            <td class="num" [class.up]="row.trend === 'up'" [class.down]="row.trend === 'down'">
              {{ row.delta > 0 ? '+' : '' }}{{ row.delta }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="sim-table-wrap" *ngIf="preofferReasons.length">
      <table class="sim-table" data-test="sim-preoffer-reasons">
        <thead>
          <tr>
            <th scope="col">En revisión por motivo</th>
            <th scope="col" class="num">{{ baselineLabel }}</th>
            <th scope="col" class="num">{{ candidateLabel }}</th>
            <th scope="col" class="num"><span class="sr-only">Cambio</span></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let reason of preofferReasons; trackBy: trackByKey">
            <td>{{ reason.label }}</td>
            <td class="num">{{ reason.baseline }}</td>
            <td class="num">{{ reason.candidate }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <ng-container *ngIf="result.sample.companies">
    <section class="sim-section">
      <h3>Bandas</h3>
      <div class="sim-table-wrap">
        <table class="sim-table" data-test="sim-bands">
          <thead>
            <tr>
              <th scope="col">Banda</th>
              <th scope="col" class="num">{{ baselineLabel }}</th>
              <th scope="col" class="num">{{ candidateLabel }}</th>
              <th scope="col" class="num">Cambio</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of bands; trackBy: trackByKey" [attr.data-test]="'sim-band-' + row.band">
              <th scope="row">
                <span class="band-pill" [ngClass]="'is-' + row.tone">{{ row.label }}</span>
              </th>
              <td class="num">
                {{ row.baseline }} <span class="pct">{{ row.baselinePct | number: '1.0-0' }} %</span>
              </td>
              <td class="num">
                {{ row.candidate }} <span class="pct">{{ row.candidatePct | number: '1.0-0' }} %</span>
              </td>
              <td class="num" [class.up]="row.delta > 0" [class.down]="row.delta < 0">{{ row.delta > 0 ? '+' : '' }}{{ row.delta }}</td>
            </tr>
            <tr class="score-row" *ngIf="result.baseline.score && result.candidate.score" data-test="sim-score">
              <th scope="row">Puntaje total de 110 (mediana · promedio)</th>
              <td class="num">{{ result.baseline.score.median | number: '1.2-2' }} · {{ result.baseline.score.mean | number: '1.2-2' }}</td>
              <td class="num">
                {{ result.candidate.score.median | number: '1.2-2' }} · {{ result.candidate.score.mean | number: '1.2-2' }}
              </td>
              <td></td>
            </tr>
            <tr class="score-row" *ngIf="result.baseline.legalGate && result.candidate.legalGate" data-test="sim-gate">
              <th scope="row">Con señales para Legal</th>
              <td class="num">{{ result.baseline.legalGate.withSignals }}</td>
              <td class="num">{{ result.candidate.legalGate.withSignals }}</td>
              <td></td>
            </tr>
            <tr class="score-row" *ngIf="result.baseline.collateral && result.candidate.collateral" data-test="sim-collateral">
              <th scope="row">Con 2º obligado solidario</th>
              <td class="num">{{ result.baseline.collateral.secondGuarantor }}</td>
              <td class="num">{{ result.candidate.collateral.secondGuarantor }}</td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <section class="sim-section">
      <h3>Cambios de banda</h3>
      <p class="sim-muted" *ngIf="!moved.length" data-test="sim-no-moves">
        Ninguna empresa cambia de banda ({{ unchanged }} se quedan igual).
      </p>
      <ng-container *ngIf="moved.length">
        <ul class="sim-moves" data-test="sim-moves">
          <li *ngFor="let move of moved">
            <span class="band-pill" [ngClass]="'is-' + move.fromTone">{{ move.from }}</span>
            <i class="pi pi-arrow-right" aria-label="pasa a"></i>
            <span class="band-pill" [ngClass]="'is-' + move.toTone">{{ move.to }}</span>
            <strong>{{ move.count }}</strong>
          </li>
          <li class="sim-muted">{{ unchanged }} se quedan igual</li>
        </ul>
        <div class="sim-table-wrap">
          <table class="sim-table" data-test="sim-changes">
            <thead>
              <tr>
                <th scope="col">Cliente</th>
                <th scope="col">{{ baselineLabel }}</th>
                <th scope="col">{{ candidateLabel }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let change of result.changes; trackBy: trackByKey">
                <td>
                  <a *ngIf="canOpenClient; else plainName" [routerLink]="['/customer', change.clientId]" target="_blank" rel="noopener">{{
                    change.clientName || 'Cliente sin nombre'
                  }}</a>
                  <ng-template #plainName>{{ change.clientName || 'Cliente sin nombre' }}</ng-template>
                </td>
                <td>
                  <span class="band-pill" [ngClass]="'is-' + bandUi[change.from.band].tone">{{ bandUi[change.from.band].label }}</span>
                  <span class="score">{{ change.from.score | number: '1.2-2' }}</span>
                </td>
                <td>
                  <span class="band-pill" [ngClass]="'is-' + bandUi[change.to.band].tone">{{ bandUi[change.to.band].label }}</span>
                  <span class="score">{{ change.to.score | number: '1.2-2' }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="sim-muted" *ngIf="result.changes.length < result.sample.companies - unchanged">
          Se listan los {{ result.changes.length }} con el salto de puntaje más grande.
        </p>
      </ng-container>
    </section>

    <section class="sim-section">
      <h3>Motivos que bajan la banda</h3>
      <p class="sim-muted" *ngIf="!reasons.length" data-test="sim-no-reasons">Ni vetos ni cobertura bajan la banda de ninguna empresa.</p>
      <div class="sim-table-wrap" *ngIf="reasons.length">
        <table class="sim-table" data-test="sim-reasons">
          <thead>
            <tr>
              <th scope="col">Motivo</th>
              <th scope="col" class="num">{{ baselineLabel }}</th>
              <th scope="col" class="num">{{ candidateLabel }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let reason of reasons; trackBy: trackByKey">
              <td>
                <span class="kind">{{ reason.kind === 'veto' ? 'Veto' : 'Cobertura' }}</span>
                {{ reason.label }}
              </td>
              <td class="num">{{ reason.baseline }}</td>
              <td class="num">{{ reason.candidate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <details class="sim-section sim-metrics">
      <summary>
        <i class="pi pi-chevron-right" aria-hidden="true"></i>
        <h3>Tramos por métrica · {{ candidateLabel }}</h3>
        <span class="sim-muted" data-test="sim-metrics-summary"
          >{{ changedMetrics }} {{ changedMetrics === 1 ? 'métrica cambia' : 'métricas cambian' }} de tramo en alguna empresa</span
        >
      </summary>
      <div class="sim-table-wrap">
        <table class="sim-table" data-test="sim-metrics">
          <thead>
            <tr>
              <th scope="col">Métrica</th>
              <th scope="col" class="num" *ngFor="let tier of tiers">{{ tier }} pts</th>
              <th scope="col" class="num">Sin dato</th>
              <th scope="col" class="num">Cambian</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let metric of metrics; trackBy: trackByKey" [class.changed]="metric.changed > 0">
              <td>{{ metric.label }}</td>
              <td class="num" *ngFor="let tier of tiers">{{ metric.tiers[tier] }}</td>
              <td class="num">{{ metric.noData }}</td>
              <td class="num">{{ metric.changed }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </details>
  </ng-container>
</ng-container>
